import { StudentActivationStatus, StudentCourseEnrolmentStatus } from '@duke-hq/svc-api-db/client';

/**
 * Enrolment statuses that represent an active (non-terminal) enrolment.
 */
export const ACTIVE_ENROLMENT_STATUSES = [
  StudentCourseEnrolmentStatus.PENDING,
  StudentCourseEnrolmentStatus.IN_PROGRESS,
  StudentCourseEnrolmentStatus.PAUSED,
] as const;

/**
 * Enrolment statuses that represent an inactive (no longer participating) enrolment.
 */
export const INACTIVE_ENROLMENT_STATUSES = [
  StudentCourseEnrolmentStatus.WITHDRAWN,
  StudentCourseEnrolmentStatus.DELETED,
] as const;

/**
 * Referral statuses that represent a resolved (no longer actionable) referral.
 */
export const TERMINAL_REFERRAL_STATUSES: readonly StudentActivationStatus[] = [
  StudentActivationStatus.CONSUMED,
  StudentActivationStatus.EXPIRED,
  StudentActivationStatus.DELETED,
];
